<template>
  <div class="caseVue">
    <header class="header">
      <h1>应用方案</h1>
      <h3>最新资讯</h3>
      <h5>核心概念与产品方案展示</h5>
    </header>
    <main>
      <b-container fluid="xl">
        <b-row class="mb-3">
          <b-col md="4" v-for="item in caseList" :key="item.id">
            <router-link
              class="hover mode wow animated flipInX"
              :to="{ path: '/quarterlyFile/programme/' + item.id }"
            >
              <div class="img">
                <b-img
                  :src="item.imagePath ? $imgUrl + item.imagePath : ''"
                  fluid
                  :alt="item.title"
                ></b-img>
              </div>
              <h2>{{ item.title }}</h2>
              <div class="description">
                {{ item.description }}
              </div>
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </main>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      caseList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  async mounted() {
    let getArchives = await this.$http.get("/getAllArchives");
    console.log(getArchives);
    if (getArchives.status == 200) {
      this.caseList = getArchives.data;
    }
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@media (min-width: 1620px) {
  .container {
    max-width: 1620px;
  }
}
.header {
  background: linear-gradient(90deg, #2d5fcd 0, #7b5ab6 100%), #2839a0;
  button {
    border-radius: 2rem;
    margin-top: 3rem;
    padding: 14px 33px;
    text-transform: uppercase;
    font-size: 16px;
    transition: 1s;
    border-style: solid;
    border-width: 1px;
    cursor: pointer;
    background-color: transparent;
    border-color: #fff;
    color: #fff;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: #409eff;
    }
  }
}

.mode {
  position: relative;
  overflow: hidden;
  img {
    height: 170px;
    width: 100%;
    display: block;
  }
  .description {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: -100%;
    left: 0;
    border-radius: 4px;
    padding: 22px 10px;
    padding: 20px;
    background-color: rgba($color: #000, $alpha: 0.5);
    color: #fff;
    transition: all 1s;
  }
  &:hover {
    .description {
      bottom: 0;
    }
  }
  &.last {
    line-height: 224px;
    text-align: center;
    border: 1px solid;
    color: #409eff;
  }
}
</style>